import {
  EmailPulseOverviewSummary,
  EmailPulseBreakdownResponse,
  EmailPulseDataResponse,
  EmailPulseTrendsResponse,
  PulseOffersResponse,
  PulseMessagesResponse,
} from '../reports-service.types';
import { createDataRow, createTotalRow } from './email-pulse.fixture-utils';

export const emailPulseOverviewSummary: EmailPulseOverviewSummary = {
  emailsSent: { value: 7462, cardType: 'number', comparisonNumber: 0.125 },
  emailsDelivered: { value: 7090, cardType: 'number', comparisonNumber: 0.118 },
  openRate: { value: 0.386, cardType: 'percent', comparisonNumber: -0.023 },
  clickRate: { value: 0.069, cardType: 'percent', comparisonNumber: 0.05 },
  unsubscribeRate: {
    value: 0.006,
    cardType: 'percent',
    comparisonNumber: 0.01,
  },
  spamReportRate: {
    value: 0.0008,
    cardType: 'percent',
    comparisonNumber: -0.02,
  },
};

export const emailPulseEmailsOpenedBreakdown: EmailPulseBreakdownResponse = {
  data: [
    { label: 'mobileOpens', value: 15234, color: '#E91E63' },
    { label: 'desktopOpens', value: 12350, color: '#00BCD4' },
    { label: 'machineOpens', value: 3200, color: '#9C27B0' },
    { label: 'notReportedOpens', value: 7000, color: '#2196F3' },
  ],
};

export const emailPulseEmailsBouncedBreakdown: EmailPulseBreakdownResponse = {
  data: [
    { label: 'hardBounces', value: 234, color: '#2196F3' },
    { label: 'softBounces', value: 138, color: '#00BCD4' },
  ],
};

export const emailPulseOverviewTrends: EmailPulseTrendsResponse = {
  series: [
    {
      label: 'Sent',
      data: [
        820, 932, 901, 934, 1290, 1330, 1320, 1450, 1380, 1420, 1360, 1400,
        1500, 1580,
      ],
    },
    {
      label: 'Delivered',
      data: [
        780, 890, 850, 890, 1230, 1270, 1260, 1380, 1320, 1350, 1300, 1340,
        1430, 1510,
      ],
    },
    {
      label: 'Opened',
      data: [
        310, 370, 340, 360, 490, 530, 500, 550, 530, 540, 520, 530, 570, 600,
      ],
    },
    {
      label: 'Clicked',
      data: [
        95, 120, 105, 115, 160, 175, 165, 185, 178, 180, 172, 176, 190, 200,
      ],
    },
    {
      label: 'Bounced',
      data: [50, 70, 60, 65, 95, 105, 98, 110, 105, 108, 104, 106, 115, 120],
    },
    {
      label: 'Dropped',
      data: [20, 30, 25, 28, 40, 45, 42, 48, 46, 47, 44, 46, 50, 52],
    },
  ],
  xlabels: [
    '2024-01-01',
    '2024-01-03',
    '2024-01-05',
    '2024-01-07',
    '2024-01-09',
    '2024-01-11',
    '2024-01-13',
    '2024-01-15',
    '2024-01-17',
    '2024-01-19',
    '2024-01-21',
    '2024-01-23',
    '2024-01-25',
    '2024-01-27',
  ],
};

export const emailPulseOverviewData: EmailPulseDataResponse = {
  data: [
    createDataRow({
      id: 'id1',
      messageId: '1',
      messageTitle: 'Welcome to the Club',
      sent: '2001',
      delivered: '1940',
      deliveryRate: '97.0%',
      emailsBounced: '61',
      emailsDropped: '15',
      emailsOpened: '931',
      uniqueOpens: '800',
      clicks: '200',
      uniqueClicks: '165',
      clickThroughRate: '8.5%',
      unsubscribes: '10',
      spamReports: '1',
      spamReportRate: '0.05%',
      openRate: '48.0%',
      clickRate: '8.5%',
      bounceRate: '3.0%',
      unsubscribeRate: '0.5%',
      emailsDeferred: '5',
      uniqueEmailsDeferred: '4',
    }),
    createDataRow({
      id: 'id2',
      messageId: '2',
      messageTitle: 'You Earned a free Side',
      sent: '1800',
      delivered: '1710',
      deliveryRate: '97.0%',
      emailsBounced: '90',
      emailsDropped: '22',
      emailsOpened: '705',
      uniqueOpens: '605',
      clicks: '150',
      uniqueClicks: '123',
      clickThroughRate: '7.2%',
      unsubscribes: '14',
      spamReports: '2',
      spamReportRate: '0.1%',
      openRate: '41.2%',
      clickRate: '7.2%',
      bounceRate: '5.0%',
      unsubscribeRate: '0.8%',
      emailsDeferred: '8',
      uniqueEmailsDeferred: '7',
    }),
    createDataRow({
      id: 'id3',
      messageId: '3',
      messageTitle: 'Today Only! BOGO',
      sent: '2200',
      delivered: '2060',
      deliveryRate: '97.0%',
      emailsBounced: '140',
      emailsDropped: '35',
      emailsOpened: '690',
      uniqueOpens: '590',
      clicks: '145',
      uniqueClicks: '120',
      clickThroughRate: '5.8%',
      unsubscribes: '12',
      spamReports: '2',
      spamReportRate: '0.09%',
      openRate: '33.5%',
      clickRate: '5.8%',
      bounceRate: '6.4%',
      unsubscribeRate: '0.6%',
      emailsDeferred: '6',
      uniqueEmailsDeferred: '5',
    }),
    createDataRow({
      id: 'id4',
      messageId: '4',
      messageTitle: 'Verify Your Account',
      sent: '1462',
      delivered: '1380',
      deliveryRate: '97.0%',
      emailsBounced: '82',
      emailsDropped: '20',
      emailsOpened: '305',
      uniqueOpens: '265',
      clicks: '75',
      uniqueClicks: '62',
      clickThroughRate: '4.5%',
      unsubscribes: '4',
      spamReports: '1',
      spamReportRate: '0.07%',
      openRate: '22.1%',
      clickRate: '4.5%',
      bounceRate: '5.6%',
      unsubscribeRate: '0.3%',
      emailsDeferred: '3',
      uniqueEmailsDeferred: '2',
    }),
  ],
  total: createTotalRow({
    sent: '7462',
    delivered: '7090',
    deliveryRate: '97.0%',
    emailsBounced: '372',
    emailsDropped: '92',
    emailsOpened: '2631',
    uniqueOpens: '2260',
    clicks: '570',
    uniqueClicks: '470',
    clickThroughRate: '6.5%',
    unsubscribes: '40',
    spamReports: '6',
    spamReportRate: '0.078%',
    openRate: '36.2%',
    clickRate: '6.5%',
    bounceRate: '5.0%',
    unsubscribeRate: '0.55%',
    emailsDeferred: '22',
    uniqueEmailsDeferred: '18',
  }),
  paging: { total: 4 },
};

// Marketing Tab Fixtures
export const emailPulseMarketingSummary: EmailPulseOverviewSummary = {
  emailsSent: { value: 5234, cardType: 'number', comparisonNumber: 15.2 },
  emailsDelivered: {
    value: 4980,
    cardType: 'number',
    comparisonNumber: 14.5,
  },
  openRate: { value: 42.3, cardType: 'percent', comparisonNumber: 3.1 },
  clickRate: { value: 8.2, cardType: 'percent', comparisonNumber: 1.2 },
  unsubscribeRate: { value: 0.4, cardType: 'percent', comparisonNumber: -0.1 },
  spamReportRate: {
    value: 0.05,
    cardType: 'percent',
    comparisonNumber: -0.03,
  },
};

export const emailPulseMarketingEmailsOpenedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'mobileOpens', value: 18450, color: '#E91E63' },
      { label: 'desktopOpens', value: 10200, color: '#00BCD4' },
      { label: 'machineOpens', value: 3200, color: '#9C27B0' },
      { label: 'notReportedOpens', value: 5900, color: '#2196F3' },
    ],
  };

export const emailPulseMarketingEmailsBouncedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'hardBounces', value: 156, color: '#2196F3' },
      { label: 'softBounces', value: 98, color: '#00BCD4' },
    ],
  };

export const emailPulseMarketingData: EmailPulseDataResponse = {
  data: [
    createDataRow({
      id: 'id1',
      messageId: '1',
      messageTitle: 'Welcome to the Club',
      sent: '2001',
      delivered: '1940',
      deliveryRate: '97.0%',
      emailsBounced: '61',
      emailsDropped: '15',
      emailsOpened: '931',
      uniqueOpens: '800',
      clicks: '200',
      uniqueClicks: '165',
      clickThroughRate: '8.5%',
      unsubscribes: '10',
      spamReports: '1',
      spamReportRate: '0.05%',
      openRate: '48.0%',
      clickRate: '8.5%',
      bounceRate: '3.0%',
      unsubscribeRate: '0.5%',
      emailsDeferred: '5',
      uniqueEmailsDeferred: '4',
    }),
    createDataRow({
      id: 'id2',
      messageId: '2',
      messageTitle: 'You Earned a free Side',
      sent: '1800',
      delivered: '1710',
      deliveryRate: '97.0%',
      emailsBounced: '90',
      emailsDropped: '22',
      emailsOpened: '705',
      uniqueOpens: '605',
      clicks: '150',
      uniqueClicks: '123',
      clickThroughRate: '7.2%',
      unsubscribes: '14',
      spamReports: '2',
      spamReportRate: '0.1%',
      openRate: '41.2%',
      clickRate: '7.2%',
      bounceRate: '5.0%',
      unsubscribeRate: '0.8%',
      emailsDeferred: '8',
      uniqueEmailsDeferred: '7',
    }),
    createDataRow({
      id: 'id3',
      messageId: '3',
      messageTitle: 'Today Only! BOGO',
      sent: '2200',
      delivered: '2060',
      deliveryRate: '97.0%',
      emailsBounced: '140',
      emailsDropped: '35',
      emailsOpened: '690',
      uniqueOpens: '590',
      clicks: '145',
      uniqueClicks: '120',
      clickThroughRate: '5.8%',
      unsubscribes: '12',
      spamReports: '2',
      spamReportRate: '0.09%',
      openRate: '33.5%',
      clickRate: '5.8%',
      bounceRate: '6.4%',
      unsubscribeRate: '0.6%',
      emailsDeferred: '6',
      uniqueEmailsDeferred: '5',
    }),
    createDataRow({
      id: 'id4',
      messageId: '4',
      messageTitle: 'Verify Your Account',
      sent: '1462',
      delivered: '1380',
      deliveryRate: '97.0%',
      emailsBounced: '82',
      emailsDropped: '20',
      emailsOpened: '305',
      uniqueOpens: '265',
      clicks: '75',
      uniqueClicks: '62',
      clickThroughRate: '4.5%',
      unsubscribes: '4',
      spamReports: '1',
      spamReportRate: '0.07%',
      openRate: '22.1%',
      clickRate: '4.5%',
      bounceRate: '5.6%',
      unsubscribeRate: '0.3%',
      emailsDeferred: '3',
      uniqueEmailsDeferred: '2',
    }),
  ],
  total: createTotalRow({
    sent: '7462',
    delivered: '7090',
    deliveryRate: '97.0%',
    emailsBounced: '372',
    emailsDropped: '92',
    emailsOpened: '2631',
    uniqueOpens: '2260',
    clicks: '570',
    uniqueClicks: '470',
    clickThroughRate: '6.5%',
    unsubscribes: '40',
    spamReports: '6',
    spamReportRate: '0.078%',
    openRate: '36.2%',
    clickRate: '6.5%',
    bounceRate: '5.0%',
    unsubscribeRate: '0.55%',
    emailsDeferred: '22',
    uniqueEmailsDeferred: '18',
  }),
  paging: { total: 4 },
};

export const emailPulseOffersData: EmailPulseDataResponse = {
  data: [
    createDataRow({
      id: 'id1',
      offerId: '5',
      offerTitle: 'Summer Sale - 20% Off',
      sent: '1650',
      delivered: '1580',
      deliveryRate: '97.0%',
      emailsBounced: '70',
      emailsDropped: '17',
      emailsOpened: '830',
      uniqueOpens: '715',
      clicks: '245',
      uniqueClicks: '194',
      clickThroughRate: '12.3%',
      unsubscribes: '5',
      spamReports: '1',
      spamReportRate: '0.03%',
      openRate: '52.5%',
      clickRate: '12.3%',
      bounceRate: '4.2%',
      unsubscribeRate: '0.3%',
      emailsDeferred: '3',
      uniqueEmailsDeferred: '2',
    }),
    createDataRow({
      id: 'id2',
      offerId: '6',
      offerTitle: 'New Menu Items This Week',
      sent: '1580',
      delivered: '1510',
      deliveryRate: '97.0%',
      emailsBounced: '70',
      emailsDropped: '17',
      emailsOpened: '692',
      uniqueOpens: '600',
      clicks: '175',
      uniqueClicks: '137',
      clickThroughRate: '9.1%',
      unsubscribes: '8',
      spamReports: '1',
      spamReportRate: '0.06%',
      openRate: '45.8%',
      clickRate: '9.1%',
      bounceRate: '4.4%',
      unsubscribeRate: '0.5%',
      emailsDeferred: '5',
      uniqueEmailsDeferred: '4',
    }),
    createDataRow({
      id: 'id3',
      offerId: '7',
      offerTitle: 'Weekend Brunch Specials',
      sent: '1420',
      delivered: '1350',
      deliveryRate: '97.0%',
      emailsBounced: '70',
      emailsDropped: '17',
      emailsOpened: '516',
      uniqueOpens: '445',
      clicks: '115',
      uniqueClicks: '92',
      clickThroughRate: '6.8%',
      unsubscribes: '5',
      spamReports: '1',
      spamReportRate: '0.05%',
      openRate: '38.2%',
      clickRate: '6.8%',
      bounceRate: '4.9%',
      unsubscribeRate: '0.4%',
      emailsDeferred: '4',
      uniqueEmailsDeferred: '3',
    }),
    createDataRow({
      id: 'id4',
      offerId: '8',
      offerTitle: 'Join Our Loyalty Program',
      sent: '584',
      delivered: '540',
      deliveryRate: '97.0%',
      emailsBounced: '44',
      emailsDropped: '11',
      emailsOpened: '179',
      uniqueOpens: '155',
      clicks: '35',
      uniqueClicks: '28',
      clickThroughRate: '5.2%',
      unsubscribes: '3',
      spamReports: '1',
      spamReportRate: '0.08%',
      openRate: '33.1%',
      clickRate: '5.2%',
      bounceRate: '7.5%',
      unsubscribeRate: '0.6%',
      emailsDeferred: '6',
      uniqueEmailsDeferred: '5',
    }),
  ],
  total: createTotalRow({
    sent: '5234',
    delivered: '4980',
    deliveryRate: '97.0%',
    emailsBounced: '254',
    emailsDropped: '63',
    emailsOpened: '2217',
    uniqueOpens: '1915',
    clicks: '570',
    uniqueClicks: '451',
    clickThroughRate: '8.2%',
    unsubscribes: '21',
    spamReports: '4',
    spamReportRate: '0.055%',
    openRate: '42.3%',
    clickRate: '8.2%',
    bounceRate: '5.0%',
    unsubscribeRate: '0.45%',
    emailsDeferred: '16',
    uniqueEmailsDeferred: '13',
  }),
  paging: { total: 4 },
};

// Orders Tab Fixtures
export const emailPulseOrdersSummary: EmailPulseOverviewSummary = {
  emailsSent: { value: 3890, cardType: 'number', comparisonNumber: 8.5 },
  emailsDelivered: {
    value: 3720,
    cardType: 'number',
    comparisonNumber: 7.8,
  },
  openRate: { value: 51.2, cardType: 'percent', comparisonNumber: 4.5 },
  clickRate: { value: 10.8, cardType: 'percent', comparisonNumber: 2.1 },
  unsubscribeRate: { value: 0.3, cardType: 'percent', comparisonNumber: -0.05 },
  spamReportRate: {
    value: 0.04,
    cardType: 'percent',
    comparisonNumber: -0.01,
  },
};

export const emailPulseOrdersEmailsOpenedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'mobileOpens', value: 22450, color: '#E91E63' },
      { label: 'desktopOpens', value: 8200, color: '#00BCD4' },
      { label: 'machineOpens', value: 3200, color: '#9C27B0' },
      { label: 'notReportedOpens', value: 4300, color: '#2196F3' },
    ],
  };

export const emailPulseOrdersEmailsBouncedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'hardBounces', value: 98, color: '#2196F3' },
      { label: 'softBounces', value: 72, color: '#00BCD4' },
    ],
  };

export const emailPulseOrdersData: EmailPulseDataResponse = {
  data: [
    createDataRow({
      id: 'id1',
      messageId: '9',
      messageTitle: 'Order Confirmation',
      sent: '1200',
      delivered: '1150',
      deliveryRate: '97.0%',
      emailsBounced: '50',
      emailsDropped: '12',
      emailsOpened: '719',
      uniqueOpens: '620',
      clicks: '265',
      uniqueClicks: '209',
      clickThroughRate: '18.2%',
      unsubscribes: '2',
      spamReports: '1',
      spamReportRate: '0.03%',
      openRate: '62.5%',
      clickRate: '18.2%',
      bounceRate: '4.2%',
      unsubscribeRate: '0.2%',
      emailsDeferred: '2',
      uniqueEmailsDeferred: '1',
    }),
    createDataRow({
      id: 'id2',
      messageId: '10',
      messageTitle: 'Order Shipped',
      sent: '1100',
      delivered: '1060',
      deliveryRate: '97.0%',
      emailsBounced: '40',
      emailsDropped: '10',
      emailsOpened: '592',
      uniqueOpens: '510',
      clicks: '158',
      uniqueClicks: '133',
      clickThroughRate: '12.5%',
      unsubscribes: '3',
      spamReports: '1',
      spamReportRate: '0.04%',
      openRate: '55.8%',
      clickRate: '12.5%',
      bounceRate: '3.6%',
      unsubscribeRate: '0.3%',
      emailsDeferred: '3',
      uniqueEmailsDeferred: '2',
    }),
    createDataRow({
      id: 'id3',
      messageId: '11',
      messageTitle: 'Order Delivered',
      sent: '980',
      delivered: '950',
      deliveryRate: '97.0%',
      emailsBounced: '30',
      emailsDropped: '7',
      emailsOpened: '459',
      uniqueOpens: '395',
      clicks: '107',
      uniqueClicks: '85',
      clickThroughRate: '8.9%',
      unsubscribes: '2',
      spamReports: '1',
      spamReportRate: '0.03%',
      openRate: '48.3%',
      clickRate: '8.9%',
      bounceRate: '3.1%',
      unsubscribeRate: '0.2%',
      emailsDeferred: '2',
      uniqueEmailsDeferred: '1',
    }),
    createDataRow({
      id: 'id4',
      messageId: '12',
      messageTitle: 'Order Ready for Pickup',
      sent: '610',
      delivered: '560',
      deliveryRate: '97.0%',
      emailsBounced: '50',
      emailsDropped: '12',
      emailsOpened: '238',
      uniqueOpens: '205',
      clicks: '52',
      uniqueClicks: '44',
      clickThroughRate: '7.8%',
      unsubscribes: '2',
      spamReports: '1',
      spamReportRate: '0.05%',
      openRate: '42.5%',
      clickRate: '7.8%',
      bounceRate: '8.2%',
      unsubscribeRate: '0.4%',
      emailsDeferred: '4',
      uniqueEmailsDeferred: '3',
    }),
  ],
  total: createTotalRow({
    sent: '3890',
    delivered: '3720',
    deliveryRate: '97.0%',
    emailsBounced: '170',
    emailsDropped: '42',
    emailsOpened: '2008',
    uniqueOpens: '1730',
    clicks: '582',
    uniqueClicks: '471',
    clickThroughRate: '10.8%',
    unsubscribes: '9',
    spamReports: '4',
    spamReportRate: '0.038%',
    openRate: '51.2%',
    clickRate: '10.8%',
    bounceRate: '4.8%',
    unsubscribeRate: '0.28%',
    emailsDeferred: '9',
    uniqueEmailsDeferred: '7',
  }),
  paging: { total: 4 },
};

// Gift Cards Tab Fixtures
export const emailPulseGiftCardsSummary: EmailPulseOverviewSummary = {
  emailsSent: { value: 2156, cardType: 'number', comparisonNumber: 12.3 },
  emailsDelivered: {
    value: 2080,
    cardType: 'number',
    comparisonNumber: 11.8,
  },
  openRate: { value: 38.5, cardType: 'percent', comparisonNumber: 2.8 },
  clickRate: { value: 6.9, cardType: 'percent', comparisonNumber: 1.5 },
  unsubscribeRate: { value: 0.5, cardType: 'percent', comparisonNumber: 0.1 },
  spamReportRate: {
    value: 0.06,
    cardType: 'percent',
    comparisonNumber: -0.02,
  },
};

export const emailPulseGiftCardsEmailsOpenedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'mobileOpens', value: 12300, color: '#E91E63' },
      { label: 'desktopOpens', value: 9450, color: '#00BCD4' },
      { label: 'machineOpens', value: 3200, color: '#9C27B0' },
      { label: 'notReportedOpens', value: 6200, color: '#2196F3' },
    ],
  };

export const emailPulseGiftCardsEmailsBouncedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'hardBounces', value: 45, color: '#2196F3' },
      { label: 'softBounces', value: 31, color: '#00BCD4' },
    ],
  };

export const emailPulseGiftCardsData: EmailPulseDataResponse = {
  data: [
    createDataRow({
      id: 'id1',
      messageId: '13',
      messageTitle: 'Gift Card Purchase Confirmation',
      sent: '850',
      delivered: '820',
      deliveryRate: '97.0%',
      emailsBounced: '30',
      emailsDropped: '7',
      emailsOpened: '371',
      uniqueOpens: '320',
      clicks: '95',
      uniqueClicks: '78',
      clickThroughRate: '9.5%',
      unsubscribes: '3',
      spamReports: '1',
      spamReportRate: '0.05%',
      openRate: '45.2%',
      clickRate: '9.5%',
      bounceRate: '3.5%',
      unsubscribeRate: '0.4%',
      emailsDeferred: '4',
      uniqueEmailsDeferred: '3',
    }),
    createDataRow({
      id: 'id2',
      messageId: '14',
      messageTitle: 'Gift Card Received',
      sent: '680',
      delivered: '660',
      deliveryRate: '97.0%',
      emailsBounced: '20',
      emailsDropped: '5',
      emailsOpened: '348',
      uniqueOpens: '300',
      clicks: '90',
      uniqueClicks: '74',
      clickThroughRate: '11.2%',
      unsubscribes: '2',
      spamReports: '1',
      spamReportRate: '0.04%',
      openRate: '52.8%',
      clickRate: '11.2%',
      bounceRate: '2.9%',
      unsubscribeRate: '0.3%',
      emailsDeferred: '3',
      uniqueEmailsDeferred: '2',
    }),
    createDataRow({
      id: 'id3',
      messageId: '15',
      messageTitle: 'Gift Card Balance Low',
      sent: '420',
      delivered: '400',
      deliveryRate: '97.0%',
      emailsBounced: '20',
      emailsDropped: '5',
      emailsOpened: '114',
      uniqueOpens: '98',
      clicks: '20',
      uniqueClicks: '17',
      clickThroughRate: '4.2%',
      unsubscribes: '3',
      spamReports: '1',
      spamReportRate: '0.09%',
      openRate: '28.5%',
      clickRate: '4.2%',
      bounceRate: '4.8%',
      unsubscribeRate: '0.8%',
      emailsDeferred: '8',
      uniqueEmailsDeferred: '7',
    }),
    createDataRow({
      id: 'id4',
      messageId: '16',
      messageTitle: 'Gift Card Expiring Soon',
      sent: '206',
      delivered: '200',
      deliveryRate: '97.0%',
      emailsBounced: '6',
      emailsDropped: '1',
      emailsOpened: '44',
      uniqueOpens: '38',
      clicks: '8',
      uniqueClicks: '7',
      clickThroughRate: '3.5%',
      unsubscribes: '1',
      spamReports: '1',
      spamReportRate: '0.06%',
      openRate: '22.0%',
      clickRate: '3.5%',
      bounceRate: '2.9%',
      unsubscribeRate: '0.5%',
      emailsDeferred: '5',
      uniqueEmailsDeferred: '4',
    }),
  ],
  total: createTotalRow({
    sent: '2156',
    delivered: '2080',
    deliveryRate: '97.0%',
    emailsBounced: '76',
    emailsDropped: '19',
    emailsOpened: '877',
    uniqueOpens: '756',
    clicks: '213',
    uniqueClicks: '176',
    clickThroughRate: '6.9%',
    unsubscribes: '9',
    spamReports: '4',
    spamReportRate: '0.06%',
    openRate: '38.5%',
    clickRate: '6.9%',
    bounceRate: '3.5%',
    unsubscribeRate: '0.5%',
    emailsDeferred: '12',
    uniqueEmailsDeferred: '10',
  }),
  paging: { total: 4 },
};

// Security & Access Tab Fixtures
export const emailPulseSecuritySummary: EmailPulseOverviewSummary = {
  emailsSent: { value: 1842, cardType: 'number', comparisonNumber: -5.2 },
  emailsDelivered: {
    value: 1790,
    cardType: 'number',
    comparisonNumber: -4.8,
  },
  openRate: { value: 68.5, cardType: 'percent', comparisonNumber: 5.2 },
  clickRate: { value: 42.8, cardType: 'percent', comparisonNumber: 6.5 },
  unsubscribeRate: { value: 0.2, cardType: 'percent', comparisonNumber: -0.05 },
  spamReportRate: {
    value: 0.03,
    cardType: 'percent',
    comparisonNumber: -0.01,
  },
};

export const emailPulseSecurityEmailsOpenedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'mobileOpens', value: 16200, color: '#E91E63' },
      { label: 'desktopOpens', value: 14800, color: '#00BCD4' },
      { label: 'machineOpens', value: 3200, color: '#9C27B0' },
      { label: 'notReportedOpens', value: 4500, color: '#2196F3' },
    ],
  };

export const emailPulseSecurityEmailsBouncedBreakdown: EmailPulseBreakdownResponse =
  {
    data: [
      { label: 'hardBounces', value: 32, color: '#2196F3' },
      { label: 'softBounces', value: 20, color: '#00BCD4' },
    ],
  };

export const emailPulseSecurityData: EmailPulseDataResponse = {
  data: [
    createDataRow({
      id: 'id1',
      emailType: 'ADMIN_PASSWORD_RESET_EMAIL',
      emailTypeDisplay: 'Admin Password Reset Confirmation',
      sent: '720',
      delivered: '700',
      deliveryRate: '97.0%',
      emailsBounced: '20',
      emailsDropped: '5',
      emailsOpened: '578',
      uniqueOpens: '500',
      clicks: '540',
      uniqueClicks: '477',
      clickThroughRate: '68.2%',
      unsubscribes: '1',
      spamReports: '1',
      spamReportRate: '0.02%',
      openRate: '82.5%',
      clickRate: '68.2%',
      bounceRate: '2.8%',
      unsubscribeRate: '0.1%',
      emailsDeferred: '1',
      uniqueEmailsDeferred: '1',
    }),
    createDataRow({
      id: 'id2',
      emailType: 'ADMIN_PASSWORD_RESET_REQUEST_EMAIL',
      emailTypeDisplay: 'Admin Password Reset Request',
      sent: '580',
      delivered: '560',
      deliveryRate: '97.0%',
      emailsBounced: '20',
      emailsDropped: '5',
      emailsOpened: '424',
      uniqueOpens: '365',
      clicks: '350',
      uniqueClicks: '294',
      clickThroughRate: '52.5%',
      unsubscribes: '1',
      spamReports: '1',
      spamReportRate: '0.03%',
      openRate: '75.8%',
      clickRate: '52.5%',
      bounceRate: '3.4%',
      unsubscribeRate: '0.2%',
      emailsDeferred: '2',
      uniqueEmailsDeferred: '1',
    }),
    createDataRow({
      id: 'id3',
      emailType: 'ADMIN_PASSWORD_UPDATE_EMAIL',
      emailTypeDisplay: 'Admin Password Updated',
      sent: '350',
      delivered: '340',
      deliveryRate: '97.0%',
      emailsBounced: '10',
      emailsDropped: '2',
      emailsOpened: '198',
      uniqueOpens: '170',
      clicks: '120',
      uniqueClicks: '98',
      clickThroughRate: '28.9%',
      unsubscribes: '1',
      spamReports: '1',
      spamReportRate: '0.04%',
      openRate: '58.2%',
      clickRate: '28.9%',
      bounceRate: '2.9%',
      unsubscribeRate: '0.3%',
      emailsDeferred: '3',
      uniqueEmailsDeferred: '2',
    }),
    createDataRow({
      id: 'id4',
      emailType: 'ADMIN_VERIFICATION_EMAIL',
      emailTypeDisplay: 'Admin Account Verification',
      sent: '192',
      delivered: '190',
      deliveryRate: '97.0%',
      emailsBounced: '2',
      emailsDropped: '0',
      emailsOpened: '93',
      uniqueOpens: '80',
      clicks: '50',
      uniqueClicks: '42',
      clickThroughRate: '22.1%',
      unsubscribes: '1',
      spamReports: '1',
      spamReportRate: '0.03%',
      openRate: '48.9%',
      clickRate: '22.1%',
      bounceRate: '1.0%',
      unsubscribeRate: '0.2%',
      emailsDeferred: '2',
      uniqueEmailsDeferred: '1',
    }),
  ],
  total: createTotalRow({
    sent: '1842',
    delivered: '1790',
    deliveryRate: '97.0%',
    emailsBounced: '52',
    emailsDropped: '13',
    emailsOpened: '1293',
    uniqueOpens: '1115',
    clicks: '1060',
    uniqueClicks: '911',
    clickThroughRate: '42.8%',
    unsubscribes: '4',
    spamReports: '4',
    spamReportRate: '0.03%',
    openRate: '68.5%',
    clickRate: '42.8%',
    bounceRate: '2.8%',
    unsubscribeRate: '0.2%',
    emailsDeferred: '5',
    uniqueEmailsDeferred: '4',
  }),
  paging: { total: 4 },
};

// Pulse Offers Filter Fixture
export const pulseOffers: PulseOffersResponse = [
  { offerId: '5', title: 'Summer Sale - 20% Off' },
  { offerId: '6', title: 'New Menu Items This Week' },
  { offerId: '7', title: 'Weekend Brunch Specials' },
  { offerId: '8', title: 'Join Our Loyalty Program' },
  { offerId: '9', title: 'Happy Hour 4-6pm' },
  { offerId: '10', title: 'Free Delivery on Orders Over $25' },
  { offerId: '11', title: 'Buy One Get One Free' },
  { offerId: '12', title: 'Birthday Month Special' },
];

// Pulse Messages Filter Fixture
export const pulseMessages: PulseMessagesResponse = [
  { messageId: '1', title: 'Welcome to the Club' },
  { messageId: '2', title: 'You Earned a free Side' },
  { messageId: '3', title: 'Today Only! BOGO' },
  { messageId: '4', title: 'Verify Your Account' },
  { messageId: '9', title: 'Order Confirmation' },
  { messageId: '10', title: 'Order Shipped' },
  { messageId: '11', title: 'Order Delivered' },
  { messageId: '12', title: 'Order Ready for Pickup' },
  { messageId: '13', title: 'Gift Card Purchase Confirmation' },
  { messageId: '14', title: 'Gift Card Received' },
  { messageId: '15', title: 'Gift Card Balance Low' },
  { messageId: '16', title: 'Gift Card Expiring Soon' },
];
